<script setup lang="ts">
/**
 * A view of a user that's not designed to be clickable, and is intended to be shown in
 * lists or menus.
 */
const props = defineProps({
  userId: null
})

const { computedPublicUserInfo } = useSavedUsers()

const user = computedPublicUserInfo(props.userId)
</script>

<template>
  <div class="user-item">
    <user-avatar
      :user="user"
      :size="16"
      class="user-item-avatar"
    />
    <div class="user-item-name">
      {{ user?.email() || "Loading..." }}
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.user-item
  @apply flex items-center gap-1.5 w-full

.user-item-avatar
  @apply flex-none

.user-item-name
  @apply w-full min-w-0 text-ellipses-inline
</style>
